import type { Maybe, Money } from 'src/types';

export const sumMoney = (moneys: Array<Maybe<Money>>): Money => {
  const filteredMoneys = moneys.filter(Boolean) as Money[];

  return filteredMoneys.reduce(
    (acc, money) => {
      if (acc.currency && money.currency !== acc.currency) {
        throw new Error('Summing multi currency not supported');
      }

      return {
        amount: acc.amount + money.amount,
        currency: money.currency,
      };
    },
    {
      amount: 0,
      currency: '',
    },
  );
};
